import { stageConfig } from '../components/Stepper/stageConfig';

/**
 *
 * @param {Number} stepId
 * @returns Retorna el id del stage en base del id de un step
 */
export function getStageIdByStepId(stepId) {
  let stageId = 0;
  stageConfig.forEach(stage => {
    if (stage?.steps?.some(step => step.stepId === Number(stepId))) {
      stageId = stage.stageId;
    }
  });
  return stageId;
}

/**
 *
 * @param {Number} stepId
 * @returns Devuelve la informacion del step buscado por id + el paso previo y siguiente
 */
export function getStepInfo(stepId) {
  let stepInfo = null;
  let flatSteps = [];
  // simplifico el array de pasos ( los saco del stage )
  stageConfig.forEach(stage => {
    flatSteps = [...flatSteps, ...stage.steps];
  });
  // recorro los pasos buscando el que necesito
  flatSteps.forEach((step, index) => {
    if (step.stepId === Number(stepId)) {
      stepInfo = step;
      stepInfo.isFirstStep = false;
      stepInfo.isLastStep = false;
      //si no es el primero le cargo prevStep
      if (step.stepId !== flatSteps[0].stepId) {
        stepInfo.prevStep = flatSteps[index - 1];
      } else {
        stepInfo.isFirstStep = true;
        stepInfo.prevStep = null;
      }
      //si no es el ultimo le cargo nextStep
      if (step.stepId !== flatSteps[flatSteps.length - 1].stepId) {
        stepInfo.nextStep = flatSteps[index + 1];
      } else {
        stepInfo.isLastStep = true;
        stepInfo.nextStep = null;
      }
    }
  });
  return stepInfo;
}
